import { ProtectedRoute } from "@/components/ProtectedRoute";
import { LessonDetailPage } from "@/pages/lesson/LessonDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/lesson/$lessonId/")({
  component: ProtectedLessonDetailPage,
});

function ProtectedLessonDetailPage() {
  return (
    <ProtectedRoute>
      <LessonDetailPage />
    </ProtectedRoute>
  );
}
